import React from 'react';
import StancerKeysForm from '../../../components/crm/StancerKeysForm';
import { Field } from './BackgroundFields';

export default function ClickCollectPaymentAdmin({ payment, onChange }) {
  const patch = (partial) => onChange({ ...payment, ...partial });

  return (
    <div className="rounded-xl border border-border bg-card p-4 sm:p-5 space-y-4">
      <label className="flex items-start gap-3 cursor-pointer">
        <input
          type="checkbox"
          className="mt-1"
          checked={payment?.enabled === true}
          onChange={(e) => patch({ enabled: e.target.checked })}
        />
        <span>
          <span className="font-medium text-foreground block">
            Paiement en ligne (Stancer)
          </span>
          <span className="text-xs text-muted-foreground leading-relaxed">
            Redirection Stancer après validation du panier. Configuration temporaire : clés
            enregistrées sur ce site uniquement.
          </span>
        </span>
      </label>

      {payment?.enabled ? (
        <Field label="Clés API Stancer">
          <StancerKeysForm
            publicKey={payment.stancerPublicKey || ''}
            privateKey={payment.stancerPrivateKey || ''}
            onPublicKeyChange={(v) => patch({ stancerPublicKey: v })}
            onPrivateKeyChange={(v) => patch({ stancerPrivateKey: v })}
            publicConfigured={payment.stancerPublicKeyConfigured}
            privateConfigured={payment.stancerPrivateKeyConfigured}
            keysConfigured={payment.stancerKeysConfigured}
            className="pt-1"
          />
          <p className="text-[11px] text-muted-foreground mt-3 leading-relaxed">
            Enregistrez avec le bouton « Enregistrer » en bas de l&apos;administration commerce.
            Les champs vides conservent les clés déjà sauvegardées.
          </p>
        </Field>
      ) : null}

      {payment?.enabled && !payment?.stancerKeysConfigured ? (
        <p className="text-xs rounded-lg bg-amber-500/10 text-amber-900 dark:text-amber-200 border border-amber-500/20 px-3 py-2">
          Saisissez la clé publique et la clé secrète Stancer pour activer le paiement.
        </p>
      ) : null}
    </div>
  );
}
